/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: NdapmL4tQ5kp
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicButtonActionPictogram.module.css"; // plasmic-import: NdapmL4tQ5kp/css
import image9NaIrE5Jwe1T from "./images/image9.svg"; // plasmic-import: naIrE5_JWE1t/picture

createPlasmicElementProxy;

export const PlasmicButtonActionPictogram__VariantProps = new Array(
  "size",
  "color",
  "status",
  "justVisible"
);

export const PlasmicButtonActionPictogram__ArgProps = new Array(
  "iconActionButton",
  "onClick"
);

const $$ = {};

function PlasmicButtonActionPictogram__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.size
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      },
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      },
      {
        path: "justVisible",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.justVisible
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.button__fRuRb,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcolor_brand]: hasVariant($state, "color", "brand"),
          [sty.rootcolor_distructive]: hasVariant(
            $state,
            "color",
            "distructive"
          ),
          [sty.rootcolor_greyOne]: hasVariant($state, "color", "greyOne"),
          [sty.rootcolor_greyTwo]: hasVariant($state, "color", "greyTwo"),
          [sty.rootcolor_white]: hasVariant($state, "color", "white"),
          [sty.rootjustVisible]: hasVariant(
            $state,
            "justVisible",
            "justVisible"
          ),
          [sty.rootsize_large]: hasVariant($state, "size", "large"),
          [sty.rootsize_medium]: hasVariant($state, "size", "medium"),
          [sty.rootsize_small]: hasVariant($state, "size", "small"),
          [sty.rootstatus_disabled]: hasVariant($state, "status", "disabled")
        }
      )}
      onClick={async event => {
        const $steps = {};
        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <PlasmicImg__
            alt={""}
            className={classNames(sty.img__zHjP2)}
            displayHeight={"100%"}
            displayMaxHeight={"none"}
            displayMaxWidth={"none"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"100%"}
            loading={"lazy"}
            src={{
              src: image9NaIrE5Jwe1T,
              fullWidth: 20,
              fullHeight: 20,
              aspectRatio: undefined
            }}
          />
        ),

        value: args.iconActionButton
      })}
    </button>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonActionPictogram__ArgProps,
          internalVariantPropNames: PlasmicButtonActionPictogram__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonActionPictogram__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicButtonActionPictogram";
  } else {
    func.displayName = `PlasmicButtonActionPictogram.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonActionPictogram = Object.assign(
  // Top-level PlasmicButtonActionPictogram renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicButtonActionPictogram
    internalVariantProps: PlasmicButtonActionPictogram__VariantProps,
    internalArgProps: PlasmicButtonActionPictogram__ArgProps
  }
);

export default PlasmicButtonActionPictogram;
/* prettier-ignore-end */
